module.exports = __webpack_public_path__ + "static/media/le-wagon-logo.9f6d221b.png";